import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {Recap, RecapsRequest, RecapsResponse} from './types'

export async function apiGetRecaps(body?: RecapsRequest): Promise<Recap | null> {
  const apiData = getApiMetadata('scribe-recaps-api-data')
  const {data} = await fetchJSONWith<RecapsResponse>(apiData.url, {method: 'GET', body})

  // Extract the first recap from the array, or return null if none exist
  return data.payload?.scribeRecapsRoute?.recaps?.[0] ?? null
}
